// eslint-disable-next-line
const UAParser = require('ua-parser-js')

const UA = new UAParser()

const DEVICE_TYPES = {
    MOBILE: "mobile",
    TABLET: "tablet",
    SMART_TV: "smarttv",
    CONSOLE: "console",
    WEARABLE: "wearable",
    BROWSER: undefined
};
const MOBILE = DEVICE_TYPES.MOBILE
const TABLET = DEVICE_TYPES.TABLET

const browser = UA.getBrowser()
const os = UA.getOS()
const device = UA.getDevice();

const isMobileAndTabletType = function isMobileAndTabletType() {
    switch (device.type) {
        case MOBILE:
        case TABLET:
            return true;
        default:
            return false;
    }
};


const getNavigatorInstance = () => {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) {
            return window.navigator || navigator;
        }
    }

    return false;
};

const isIOS13Check = (type) => {
    var nav = getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform ===
        'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

const getIPad13 = () => {
    return isIOS13Check('iPad');
};

const isMobile = isMobileAndTabletType() || getIPad13();
const browserName = browser.name
const browserVersion = browser.version
const osName = os.name ? os.name : "none"


export function checkBrowserSupport() {
  const browser = browserName.toLowerCase()
  const version = Number(browserVersion.split('.')[0])
  const os = osName.toLowerCase()

  const notSupportedDesktop = {
    chrome: { below: 41 },
    opera: { below: 28 },
    firefox: { below: 41 },
    safari: { below: 10 },
    edge: { fullySupported: true },
    yandex: { notSupported: true },
    ie: { notSupported: true },
  }

  const notSupportedMobile = {
    ios: { below: 10 },
    android: { below: 4 }
  }

  const rules = isMobile ? notSupportedMobile[os] : notSupportedDesktop[browser]

  if (!rules) return true
  if (rules.notSupported) return false
  if (rules.fullySupported) return true
  if (isNaN(version)) return true
  if (rules.below != null && version < rules.below) return false
  return true
}

